module.exports = __webpack_public_path__ + "img/Objet dynamique vectoriel4-04.a439794b.png";